import { SheetContent } from '../components/ui/sheet';
import { usePortalDestination } from './PortalDestinationContext';
import { buildPharmacyTokens } from './lib/portalTheme';
import { usePortalTheme } from './PortalThemeContext';

/**
 * Drop-in replacement for the raw shadcn <SheetContent> for any portal
 * bottom sheet. Radix portals sheet content straight to <body>, outside
 * the `.portal-brand` DOM subtree, so without this wrapper the sheet never
 * sees the pharmacy's brand tokens or the active light/dark theme.
 */
export const PortalSheetContent = ({ className = '', children, style, ...props }) => {
  const destination = usePortalDestination();
  const { theme } = usePortalTheme();
  return (
    <SheetContent {...props} style={{ ...buildPharmacyTokens(destination?.pharmacy, theme), ...style }}
      className={`portal-brand ${className}`}>
      {children}
    </SheetContent>
  );
};
